export enum LogoType {
  Text = 'text',
  Image = 'image',
}

export enum LogoVersion {
  Light = 'light',
  WithColor = 'with-color',
}
